export default __webpack_public_path__ + "static/media/rocket.b0b05acd.svg";